import Vue from 'vue';
// preload fe-billing-common components
import { BIZ_PLUS_PLAN_DETAILS as FeatureULForBizPlus } from '@zoom/billing-shared';
import { PRO_PLUS_PLAN_DETAILS as FeatureULForProPlus } from '@zoom/billing-shared';
import {
  PLAN_COMPARISON as PlanComparison,
  PLAN_COMPARISON_MOBILE as PlanComparisonMobile,
} from '@zoom/billing-shared';
import { WEBINAR_EXPLAIN_DIALOG as WebinarExplainDialog } from '@zoom/billing-shared';
import {
  ZOOM_ONE_EDU_PLAN_DETAIL_DIALOG as ZoomOneEduPlanDetail,
  ZOOM_ONE_EDU_PLAN_COMPARISON as ZoomOneEduPlanComparison,
  PRICE_VAT_TIP as priceVATTip
} from '@zoom/billing-shared';
const modules = [
  ['FeatureULForBizPlus', FeatureULForBizPlus],
  ['FeatureULForProPlus', FeatureULForProPlus],
  ['PlanComparison', PlanComparison],
  ['PlanComparisonMobile', PlanComparisonMobile],
  ['WebinarExplainDialog', WebinarExplainDialog],
  ['ZoomOneEduPlanDetail', ZoomOneEduPlanDetail],
  ['ZoomOneEduPlanComparison', ZoomOneEduPlanComparison],
  ['priceVATTip', priceVATTip],
];

function preLoad(modules) {
  modules.forEach(([key, module]) => {
    if (module) {
      module().then((moduleId) => {
        if (moduleId?.default) {
          Vue.component(key, moduleId.default);
        }
      });
    } else {
      console.log(`[fe-billing-common]: can not find module name => ${key}`);
    }
  });
}

preLoad(modules);
